export enum CityFields {
	ID = "id",
	NAME = "name",
	DESCRIPTION = "description",
	STATE = "state"
}

export type CityProps = {
	[CityFields.ID]: string;
	[CityFields.NAME]: string;
	[CityFields.DESCRIPTION]?: string;
	[CityFields.STATE]?: string;
};

export enum AddressFields {
	ID = "id",
	POSTAL_CODE = "postalCode",
	STREET = "street",
	NUMBER = "number",
	COMPLEMENT = "complement",
	NEIGHBOURHOOD = "neighbourhood",
	CITY = "city"
}

export type AddressProps = {
	[AddressFields.ID]: string;
	[AddressFields.POSTAL_CODE]: string;
	[AddressFields.STREET]: string;
	[AddressFields.NUMBER]: number;
	[AddressFields.COMPLEMENT]: string;
	[AddressFields.NEIGHBOURHOOD]: string;
	[AddressFields.CITY]: CityProps;
};

export enum EstablishmentFields {
	ID = "id",
	LEGAL_NAME = "legalName",
	TRADE_NAME = "tradeName",
	CNPJ = "cnpj",
	STATUS = "status",
	CREATED_AT = "createdAt",
	ADDRESS = "address",
	IE = "ie",
	CONTACT_PHONE = "contactPhone",
	CONTACT_WHATSAPP = "contactWhatsapp",
	CONTACT_INSTAGRAM = "contactInstagram",
	CONTACT_FACEBOOK = "contactFacebook",
	SITE_URL = "siteUrl",
	TERM = "term",
	RESPONSIBLE_NAME = "responsibleName",
	RESPONSIBLE_PHONE = "responsiblePhone",
	RESPONSIBLE_EMAIL = "responsibleEmail",
	RESPONSIBLE_CPF = "responsibleCpf",
	RESPONSIBLE_ROLE = "responsibleRole",
	IMAGE = "image",
	REMARK = "remark",
	UPDATED_AT = "updatedAt",
	UPDATED_BY = "updatedBy"
}

export type EstablishmentProps = {
	[EstablishmentFields.ID]: string;
	[EstablishmentFields.LEGAL_NAME]: string;
	[EstablishmentFields.TRADE_NAME]: string;
	[EstablishmentFields.CNPJ]: string;
	[EstablishmentFields.STATUS]: string;
	[EstablishmentFields.CREATED_AT]: string;
	[EstablishmentFields.ADDRESS]: AddressProps;
	[EstablishmentFields.IE]?: number;
	[EstablishmentFields.CONTACT_PHONE]?: number;
	[EstablishmentFields.CONTACT_WHATSAPP]?: number;
	[EstablishmentFields.CONTACT_INSTAGRAM]?: string;
	[EstablishmentFields.CONTACT_FACEBOOK]?: string;
	[EstablishmentFields.SITE_URL]?: string;
	[EstablishmentFields.TERM]?: string;
	[EstablishmentFields.RESPONSIBLE_NAME]?: string;
	[EstablishmentFields.RESPONSIBLE_PHONE]?: number;
	[EstablishmentFields.RESPONSIBLE_EMAIL]?: string;
	[EstablishmentFields.RESPONSIBLE_CPF]?: string;
	[EstablishmentFields.RESPONSIBLE_ROLE]?: string;
	[EstablishmentFields.REMARK]?: string;
	[EstablishmentFields.UPDATED_AT]?: string;
	[EstablishmentFields.UPDATED_BY]?: string;
	[EstablishmentFields.IMAGE]: string;
};

export enum CategoryFields {
	ID = "id",
	NAME = "name"
}

export type CategoryProps = {
	[CategoryFields.ID]: string;
	[CategoryFields.NAME]: string;
};

export enum PartnerFields {
	ID = "id",
	TENANT_ID = "tenantId", //  TODO: Validar se vale a pena mudar o formato para retornar o tenant
	NAME = "name",
	DESCRIPTION = "description",
	LOGO_URL = "image",
	ESTABLISHMENT_IMAGE_URL = "establishment_image",
	STATUS = "status",
	CREATED_AT = "createdAt",
	UPDATED_AT = "updatedAt",
	UPDATED_BY = "updatedBy",
	CATEGORIES = "categories",
	CATEGORY_IDS = "categoryIds",
	ESTABLISHMENTS = "establishments"
}

export type PartnerProps = {
	[PartnerFields.ID]: string;
	[PartnerFields.TENANT_ID]: string;
	[PartnerFields.NAME]: string;
	[PartnerFields.DESCRIPTION]: string;
	[PartnerFields.STATUS]: number;
	[PartnerFields.CREATED_AT]: string;
	[PartnerFields.UPDATED_AT]: string;
	[PartnerFields.UPDATED_BY]: string;
	[PartnerFields.CATEGORIES]: CategoryProps[];
	[PartnerFields.ESTABLISHMENTS]: EstablishmentProps[];
};
